import React, { FC, lazy } from 'react';
import { modalRoutes } from 'constants/routes';
import UserPermissionGate from 'components/UserPermissionGate';
import { UserPermission } from 'constants/userPermission';
import ModalRoute from 'context/ModalRouter';
import PostModal from 'app/modules/posts/modules/post';
import RespondToApprovalModal from 'app/modules/posts/modules/respontToApprovalRequest/RespondToApprovalModal';
import SharePreview from 'pages/posts/post/SharePreview';
import ChangePostsStatus from 'pages/posts/workflowOptions/ChangePostsStatus';
import AssignMultipleTasksPage from 'app/modules/posts/modules/assignMultipleTasks';
import SchedulePosts from 'pages/posts/workflowOptions/SchedulePosts';
import DashboardDuplicatePostsModal from 'app/modules/dashboard/modules/posts/components/duplicatePosts';
import MovePosts from 'app/modules/dashboard/modules/posts/components/movePosts';
import MovePostsToTrashRoute from 'app/modules/posts/modules/movePostsToTrash';
import SendForClientApproval from 'pages/posts/workflowOptions/SendForClientApproval';
import SendForInternalApproval from 'pages/posts/workflowOptions/SendForInternalApproval';

const PostModalNew = lazy(
  () => import('app/modules/posts/modules/post/new/PostModal'),
);

type Props = {};

const ApprovalsModals: FC<Props> = (props) => {
  return (
    <>
      <ModalRoute path={modalRoutes.POST_DETAIL} component={PostModal} />
      <ModalRoute path={modalRoutes.POST_DETAIL_NEW} component={PostModalNew} />

      <ModalRoute
        path={modalRoutes.RESPOND_TO_APPROVAL_REQUEST}
        component={RespondToApprovalModal}
      />

      <UserPermissionGate scopes={UserPermission.POST_DELETE}>
        <ModalRoute
          path={modalRoutes.MOVE_POSTS_TO_TRASH}
          component={MovePostsToTrashRoute}
        />
      </UserPermissionGate>

      <UserPermissionGate scopes={UserPermission.POST_DUPLICATE}>
        <ModalRoute
          path={modalRoutes.DUPLICATE_POSTS}
          component={DashboardDuplicatePostsModal}
        />
      </UserPermissionGate>

      <UserPermissionGate scopes={UserPermission.POST_MOVE}>
        <ModalRoute path={modalRoutes.MOVE_POSTS} component={MovePosts} />
      </UserPermissionGate>

      <UserPermissionGate scopes={UserPermission.POST_SCHEDULE}>
        <ModalRoute
          path={modalRoutes.SCHEDULE_POSTS}
          component={SchedulePosts}
        />
      </UserPermissionGate>

      <UserPermissionGate scopes={UserPermission.POST_MASS_CHANGE_POST_STATUS}>
        <ModalRoute
          path={modalRoutes.CHANGE_POSTS_STATUS}
          component={ChangePostsStatus}
        />
      </UserPermissionGate>

      <UserPermissionGate scopes={UserPermission.POST_SHARE_PREVIEW}>
        <ModalRoute path={modalRoutes.SHARE_PREVIEW} component={SharePreview} />
      </UserPermissionGate>

      <UserPermissionGate scopes={UserPermission.USER_ASSIGN_TASK}>
        <ModalRoute
          path={modalRoutes.ASSIGN_MULTIPLE_TASKS}
          component={AssignMultipleTasksPage}
        />
      </UserPermissionGate>

      <UserPermissionGate scopes={UserPermission.POST_SEND_FOR_CLIENT_APPROVAL}>
        <ModalRoute
          path={modalRoutes.SEND_FOR_CLIENT_APPROVAL}
          component={SendForClientApproval}
        />
      </UserPermissionGate>

      <UserPermissionGate
        scopes={UserPermission.POST_SEND_FOR_INTERNAL_APPROVAL}
      >
        <ModalRoute
          path={modalRoutes.SEND_FOR_INTERNAL_APPROVAL}
          component={SendForInternalApproval}
        />
      </UserPermissionGate>
    </>
  );
};

export default ApprovalsModals;
